import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3TransactionsEdit } from "./edit";
import { C3TransactionsNew } from "./new";
import { C3TransactionsTable } from "./table";

export default function C3Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<C3TransactionsNew />} />
      <Route path=":id" element={<C3TransactionsEdit />} />
      <Route index element={<C3TransactionsTable />} />
    </Routes>
  );
}
